function setUrlParams(url: URL, name: string, value: string): URL;
function setUrlParams(url: URLSearchParams, name: string, value: string): URLSearchParams;
function setUrlParams(url: URL, params: { [key: string]: string | null }): URL;
function setUrlParams(
  url: URLSearchParams,
  params: { [key: string]: string | null }
): URLSearchParams;
function setUrlParams(
  url: URL | URLSearchParams,
  params: { [key: string]: string } | string,
  value?: string
): URL | URLSearchParams {
  const searchParams = url instanceof URL ? url.searchParams : url;

  if (typeof params === 'object') {
    Object.keys(params).forEach((key) => {
      if (params[key]) {
        searchParams.set(key, params[key]);
      } else {
        searchParams.delete(key);
      }
    });
  } else {
    searchParams.set(params, value);
  }

  return url;
}

export default setUrlParams;
